export function determineFundRisk({ scoreList, codeRange, currentCodeRange }) {
  if (!Array.isArray(scoreList) || !codeRange || !currentCodeRange) return null;

  const currentRisk = scoreList.find(
    item =>
      parseInt(currentCodeRange) >= parseInt(item.lowerBound) &&
      parseInt(currentCodeRange) <= parseInt(item.upperBound)
  );

  if (parseInt(codeRange) >= currentRisk?.upperBound) {
    return "HIGH_RISK";
  }

  return "STANDART_RISK";
}
